import { Input } from 'antd'

export default AclEntityFilter = ({ type, filterFn }) ->
  <Input
    allowClear
    placeholder={"Filter #{ type or 'projects' } "}
    onChange={({ target: { value } })-> filterFn(value)}
  />
